<div [id]="getWidgetId">
    @if (isRemovedFromCatalog) {
        <div class="removed-from-catalog-notice">
            <span class="text">{{ "widget_product_removed_from_catalog" | translate }}</span>
        </div>
    }

    @if (!isShowCardSettings) {
        <div [class]="classes?.blankImageWrapper">
            <img [src]="'./assets/img/websites/lpc-empty-product-icon.svg'" alt="product_blank" />
            <span>{{ "widget_product_empty_blank" | translate }}</span>
        </div>
    } @else {
        <div [class.removed-from-catalog-card]="isRemovedFromCatalog">
            @if (modalCardType) {
                <web-modal-view-card [data]="widgetData" [classes]="classes"></web-modal-view-card>
            }
            @if (openCardType) {
                <web-open-view-card [data]="widgetData" [classes]="classes" [widgetId]="widget.id"></web-open-view-card>
            }
        </div>
    }
</div>
